import React, { useEffect, useCallback } from "react";
import { styled } from "@mui/material/styles";
import {Box, List, ListItem, Grid, Button, Divider, TextField, MenuItem } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { budgetActions } from "../actions/budget.action";
import { accountActions } from "../actions/account.action";
import { Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
// import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import TransactionDialog from "../Pages/TransactionDialog/TransactionDialog";
import MonthlyValDialog from "./MonthlyValDialog";
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Tooltip from "@mui/material/Tooltip";
import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import { currencyFormat, getBadgeClasses, getOrdinal, escapeHtml } from "../helpers/common";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { toast } from "react-toastify"; // ToastContainer,
import "react-toastify/dist/ReactToastify.css";
import FileOpenIcon from '@mui/icons-material/FileOpen';
import axiosInstance from "../interceptor/interceptor";
import SortIcon from '@mui/icons-material/Sort';
import { transactionService } from "../services/transaction.service";
import { userService } from "../services/user.service";
// packages for web version
import DownloadIcon from '@mui/icons-material/Download';
import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from "react-router-dom";

import { sortingType } from "../helpers/constants";
const Demo = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
}));

const MonthlyTransaction = (props) => {
  // const [dense, setDense] = React.useState(false);
  // const [secondary, setSecondary] = React.useState(false);
  const [year, setYear] = React.useState(new Date().getFullYear());
  const [session, setSession] = React.useState('');

  const monthlyExpenseList = useSelector(
    (state) => state.budgetReducer.monthlyExpenseList
  );

  const currency = useSelector(
    (state) => state.userReducer.currency
  );

  const hideIncome = useSelector(
    (state) => state.userReducer.hideIncome
  );


  const defaultBudget = useSelector(
    (state) => state.userReducer?.loggedInData?.default_budget
  );

  const monthlyIncomeList = useSelector(
    (state) => state.budgetReducer.monthlyIncomeList
  );
  const totalBudget = useSelector((state) => state.budgetReducer.totalBudget);
  const totalSpent = useSelector((state) => state.budgetReducer.totalSpent);
  const totalIncome = useSelector((state) => state.budgetReducer.totalIncome);

  const startDate = useSelector((state) => state.varsReducer.startDate);
  const endDate = useSelector((state) => state.varsReducer.endDate);

  const isLoading = false; //useSelector((state) => state.budgetReducer.isLoading);
  const [budgetId, setBudgetId] = React.useState("");
  const [budgetName, setName] = React.useState("");
  const [tagId, setTagId] = React.useState("");
  const [accountId, setAccountId] = React.useState("");
  const [budgetAmount, setBudgetAmount] = React.useState("");
  const [transactionType, setTransactionType] = React.useState("");
  const [nextBillName, setNextBillName] = React.useState("");
  const [openTransactionDialog, setOpenTransactionDialog] = React.useState(false);
  const [openMonthlyValDialog, setOpenMonthlyValDialog] = React.useState(false);
  const [showSorting, setShowSorting] = React.useState(false);
  const [monthId, setMonthId] = React.useState("");
  const [showLoading, setShowLoading] = React.useState(false);
  const [transactionDate, setTransactionDate] = React.useState('');
  const [sortBy, setSortBy] = React.useState(userService.decryptData(localStorage.getItem('items_text_obj'), 'base64') || "");
  const [transactionId, setTransactionId] = React.useState('');
    
  const [note, setNote] = React.useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Component Did Mount
  useEffect(() => {
    fetchData();    
  }, [props]);

  // Component Did Update
  useEffect(() =>{
    fetchData();
  }, [startDate, endDate]);

  // Component Did Update
  useEffect(() =>{
    // Code to find next payment    
      findNextPayment();
  }, [startDate, monthlyExpenseList]);  

  // Component Did Update
  useEffect(() =>{
    if(sortBy !== ""){
      localStorage.setItem('items_text_obj', userService.encryptData(sortBy,'base64'));
      refreshData();
    }
  }, [sortBy]);

  // Component Did Update
  useEffect(() =>{
    if(openTransactionDialog === false){
      setName("");
      setTagId("");
      setAccountId("");
      setBudgetAmount(0);
      setTransactionDate("");
      setNote("");
      setTransactionId("");
    }
  }, [openTransactionDialog]);

  const  sortingHandler = (e) => {
    setSortBy(e.target.value);
    // update sort_by data over server
    updateSortBy(e.target.value);
  }

  const findNextPayment =() => {
    if(monthlyExpenseList){
      let nextBill = false;
      const todayDate = new Date();
      const dateFormatted = `${todayDate.getFullYear()}-${todayDate.getMonth()+1}-${todayDate.getDate()}`;
      for(let i=0; i< monthlyExpenseList.length; i++){
        // console.log(monthlyExpenseList[i].sum, 'Sum', monthlyExpenseList[i].amount, "amount", new Date(monthlyExpenseList[i].payment_date), "payment date", new Date(dateFormatted).getTime(), "current date");
        // break;
        // if(monthlyExpenseList[i].sum === 0 && monthlyExpenseList[i].amount !== 0 && new Date(monthlyExpenseList[i].payment_date).getTime()< new Date(dateFormatted).getTime()){
        //   monthlyExpenseList[i].pending_payment = "Yes";
        // }
        if(monthlyExpenseList[i].sum === 0 && monthlyExpenseList[i].amount !== 0 && new Date(monthlyExpenseList[i].payment_date).getTime()>= new Date(dateFormatted).getTime()){
          setNextBillName(monthlyExpenseList[i].name);
          nextBill = true;
          break;
        }
      }
      if(nextBill === false){
        setNextBillName("");
      }
    }
  }

  // Update user sort by
  const updateSortBy = async (sort_by) =>{
    const res = await axiosInstance.post(
      `api?method=update_user_sort_by`,
      { user_id: localStorage.getItem('user_text_obj_data1'), sort_by: sort_by }
    );
    setTimeout(()=>{
      setShowSorting(false);
    },10000);
  }

  // downladPDF
  const downloadPDF = () => {
    if (window.confirm("Sure to download the PDF file for current month cycle?")) {
      var doc = new jsPDF();
      doc.text('MoneyTrek - Budget & Expenses', 15, 20);
      const columns = ["Category", "Date", "Amount", "Notes"];
      const rows = [];
      let itemRow = [];
      let totalAmount = 0;
      monthlyExpenseList.forEach((item)=>{
        if(item.transactions.length >0){
            item.transactions.forEach((transactions, index)=>{
                // Define the table columns and rows
                totalAmount = totalAmount + transactions.amount;
                const tempDate = new Date(transactions.transaction_date).getDate() +" " + new Date( transactions.transaction_date ).toLocaleString("default", { month: "short" }) +" "+ new Date(transactions.transaction_date).getFullYear();

                if(index === 0){
                    itemRow = [item.name, tempDate, transactions.amount.toLocaleString('en-IN'),transactions.note];
                }
                else {
                    itemRow = ['', tempDate, transactions.amount.toLocaleString('en-IN'),transactions.note];
                }
                rows.push(itemRow);
            });
        }
      })
      itemRow = ['', '', '',''];
      rows.push(itemRow);
      totalAmount = `Rs ${totalAmount.toLocaleString('en-IN')}`;
      itemRow = ['Total Expenditure', '',totalAmount ,''];
      rows.push(itemRow);

        // Set the table options
        const options = {
        startY: 30, // Vertical position to start the table (in mm)
        };
        // Generate the table
        doc.autoTable(columns, rows, options);
      doc.save('moneytrek-expenses.pdf');
    }
    
  }
  // Fetch Data
  const fetchData = () =>{
    // Code to check if month is current month
    const currentDate = new Date();
    if(currentDate.setHours(0,0,0,0) >= new Date(startDate).setHours(0,0,0,0) && currentDate.setHours(0,0,0,0) <= new Date(endDate).setHours(0,0,0,0)){
      setSession('current');
    }
    else if(currentDate <= new Date(startDate)) {
      setSession('next');
    }
    else {
      setSession('previous');
    }
    setTimeout(()=>{
      manageSwipe();
    },3000);
    refreshData();
    const classNode = document.getElementsByClassName('transactions');
    for (const box of classNode) {
      box.style.display = 'none'; // 👇️ removes element from DOM
      // box.style.visibility = 'hidden'; // 👇️ hides element
    }
    const classNode2 = document.getElementsByClassName('show-list-icon');
    for (const box of classNode2) {
      box.style.display = 'block';
    }
    const classNode3 = document.getElementsByClassName('hide-list-icon');
    for (const box of classNode3) {
      box.style.display = 'none';
    }
  }

  // Manage Swipe 
  // Implemented from: http://www.javascriptkit.com/javatutors/touchevents2.shtml
  function manageSwipe(){
    let swipedir,
    startX,
    startY,
    distX,
    distY,
    threshold = 75, //required min distance traveled to be considered swipe
    restraint = 100,
    allowedTime = 1000, // maximum time allowed to travel that distance
    elapsedTime,
    startTime;

        // Swipe Feature code
        try{
          const touchsurface = document.getElementById('expense-section') || document.getElementById('income-section');
          if(touchsurface){
            touchsurface.addEventListener('touchstart', (e)=>{
              let touchobj = e.changedTouches[0]
              // console.log(touchobj,'touchobj!!');
              startX = touchobj.pageX;
              startY = touchobj.pageY;
              distX = 0;
              startTime = new Date().getTime(); // record time when finger first makes contact with surface
              // e.preventDefault();
            }, false);
          
            touchsurface.addEventListener('touchend', (e)=>{
              let touchobj = e.changedTouches[0];
              distX = touchobj.pageX - startX; // get total dist traveled by finger while in contact with surface
              distY = touchobj.pageY - startY; // get vertical dist traveled by finger while in contact with surface
              elapsedTime = new Date().getTime() - startTime; // get time elapsed
              // console.log(touchobj.pageX +'-'+ startX)
              // check that elapsed time is within specified, horizontal dist traveled >= threshold, and vertical dist traveled <= 100
              // console.log(distX,'distX!!!', Math.abs(distY));
              if(elapsedTime <= allowedTime){ // first condition to check if there is a swipe
                if((Math.abs(distX) >= threshold && Math.abs(distY) <= restraint) || (Math.abs(distX) >= 40 && Math.abs(distY) <= 10)){
                  swipedir = (distX < 0)? 'left' : 'right';
                  props.parentCallback(swipedir);
                  e.preventDefault();
                } 
              }
              //  var swiperightBol = (elapsedTime <= allowedTime && distX >= threshold && Math.abs(touchobj.pageY - startY) <= 100)
          
              // e.preventDefault()
          }, false)
        }

    }
    catch(e){
      console.error(e,'catch block error Monthly Transaction');
    }
  
    // End Swipe Code
  }

  function fetchMonthlyBudget(startDate, endDate, callFrom = null) {
    try {
      const user_id = localStorage.getItem("user_text_obj_data1");
      dispatch(
        budgetActions.getMonthlyBudget({
          user_id: user_id,
          start_date: startDate,
          end_date: endDate,
          callFrom: callFrom,
          budget_type: props.budgetType,
          sort_by: userService.decryptData(localStorage.getItem('items_text_obj'),'base64')
        })
      );
      dispatch(accountActions.fetchAccounts({user_id: user_id}));
    } catch (e) {
      console.error(e,'catch block error Monthly Transaction');
    }
  }

  // show transactions
  const showTransactions = (event, index) => {
    const node = document.getElementById(`list${index}`);
      // event.target.parentElement.parentElement.parentElement.parentElement.querySelector(
      //   ".transactions"
      // );
    if (node.style.display === "none") {
      node.style.display = "block"; // show list
      document.getElementById(`strike${index}`).style.display = "block";
      document.getElementById(`show${index}`).style.display = "none";

    } else {
      node.style.display = "none"; // hide list
      document.getElementById(`strike${index}`).style.display = "none";
      document.getElementById(`show${index}`).style.display = "block";
    }
  };

  // Payment dialog methods
  const closeDialogHandler = useCallback(function _handleClose() {
    setOpenTransactionDialog(false);
    findNextPayment();
    // refreshData();
    // dispatch(
    //   budgetActions.getBudgetList2({ user_id: localStorage.getItem("user_text_obj_data1"), status:1 })
    // );
  }, []);
  // Open Add Transaction dialog
  function addTransactionHandler(budget_id, name, amount, transactiontype) {
    setBudgetId(budget_id);
    setName(name);
    setBudgetAmount(amount);
    setTransactionType(transactiontype);
    setOpenTransactionDialog(true);
  }
  // Open Edit Transaction dialog
  function editTransactionHandler(obj,name, transactiontype) {
    setName(name);
    setTagId(obj.tag_id);
    setAccountId(obj.account_id);
    setBudgetAmount(obj.amount);
    setTransactionDate(obj.transaction_date);
    setNote(obj.note);
    setTransactionId(obj.transaction_id);
    setTransactionType(transactiontype);
    setOpenTransactionDialog(true);
  }

    // Monthly dialog methods
    const closeDialog2Handler = useCallback(function _handleClose() {
      setOpenMonthlyValDialog(false);
    }, []);
  

  function refreshData() {
    if (startDate != null && endDate != null) {
      fetchMonthlyBudget(startDate, endDate, "server");
    }
  }

  function deleteTransaction(id){
    let result = window.confirm("Sure to delete?");
    if(result){
    setShowLoading(true);
    transactionService.deleteTransaction({transaction_id:id}).then(
      (response) => {
        setShowLoading(false);
        refreshData();
        // fetchMonthlyBudget(startDate, endDate, "server");
        toast.info(`${response.data.message}`, { type: "success" });
      }).catch(err=>{
        toast.info(`${err.response.data.message}`, { type: "error" });
      })
    } else {
      return false;
    }
  }

  function showHideSorting(){
    setShowSorting(!showSorting);
  }
  function redirectToSearch(){
    navigate('/search', { replace: true });
  }
  return (
    <Box>
      {/* Monthwise value updation dialog  */}
      <MonthlyValDialog
        open={openMonthlyValDialog}
        closeHandler={closeDialog2Handler}
        budgetId={budgetId}
        budgetName={budgetName}
      />
      
      {/* Payment dialog updation dialog  */}
      <TransactionDialog
        open={openTransactionDialog}
        closeHandler={closeDialogHandler}
        budgetId={budgetId}
        tagId={tagId}
        accountId={accountId}
        budgetName={budgetName}
        refreshData={refreshData}
        budgetAmount={budgetAmount}
        month={monthId}
        year={year}
        transactionId={transactionId}
        transactionDate={transactionDate}
        note={note}
        transactionType={transactionType}
      />

      {isLoading || showLoading ? (
        <div id="overlay">
          <div className="loader">
            <CircularProgress />
          </div>
        </div>
      ) : (
        <></>
      )}
      <Grid container className="amount-box-container">
        {props.budgetType === "expense" ? (
          <>
          {defaultBudget === "1" ? (
              <Box component="span" m="{1}" className="default-budget">
                The values shown below are default. You can update with actual values by navigating on the user icon &rarr; Budgets Section.
            </Box>
          ):(
          <></>
          )}
            <Grid container className="amount-container">
              {(session =="current" || session =="next")?(
                <Grid item xs={3} >
                  <Box className="amount-box"><span>Budget:</span><br/>{currencyFormat(totalBudget, currency)}</Box>
                  </Grid>
              ):(<></>)}
              { hideIncome === false && (
                <Grid item xs={3} >
                <Box className="amount-box"><span>Income:</span><br/> {currencyFormat(totalIncome, currency)}</Box>
                </Grid>
              )}
              
              <Grid item xs={3}>
                <Box className="amount-box"><span>Spent:</span><br/> {currencyFormat(totalSpent, currency)}</Box>
                </Grid>
                { hideIncome === false && (
              <Grid item xs={3}>
                <Box className="amount-box"><span>Balance:</span><br/> {currencyFormat(totalIncome - totalSpent, currency)}</Box>
              </Grid>
                )}
                 { hideIncome === true && (
              <Grid item xs={6}>
              </Grid>
                )}
              <Grid item xs={6}>
                {(nextBillName !=="" && session=="current")?(
                <Box className="next-pay">
                  <span>Next Payment: <span style={{color:'#000'}}>{escapeHtml(nextBillName)} </span></span>
                </Box>
              ):(<></>)}
                
                </Grid>
              <Grid item xs={6} justifyContent="flex-end" style={{textAlign:'right'}}>
                <Button onClick={redirectToSearch} className="sorting-box">
                  <SearchIcon fontSize="small" style={{color:"cadetblue"}}/>
                </Button>
                <Button onClick={downloadPDF} className="sorting-box">
                  <DownloadIcon fontSize="small"  style={{color:"cadetblue"}}/>
                </Button>
                {/* sx={{ color: "#fff" }} */}
                <Button onClick={showHideSorting} className="sorting-box">
                  <SortIcon fontSize="small" style={{color:"cadetblue"}}/>
                </Button>
              </Grid> 
            </Grid>
            
            <Grid item xs={12} md={12} id="expense-section">
            {showSorting ? (
              <div className="sorting-container">
              <span style={{padding: '14px', fontSize:'14px'}}>Sort By:</span>
              <TextField
                      id="select type"
                      style={{ marginBottom: "10px", width: "42%" }}
                      select
                      label="Select"
                      name="select"
                      defaultValue={sortBy}
                      onChange={sortingHandler}
                    >
                      {sortingType.map((option) => (
                        <MenuItem key={option.value} value={option.value} >
                          {option.label}
                        </MenuItem>
                      ))}
                </TextField>
            </div>
            ) : (
              <></>
            )}
              
              <Demo style={{ minHeight: "500px" }}>
                {monthlyExpenseList && monthlyExpenseList.length > 0 ? (
                  <List>
                    {monthlyExpenseList.map((data, index) => (
                      <div key={index}>
                        <ListItem
                          className={getBadgeClasses(data,session) + " list-transaction"} 
                          secondaryAction={
                            <>
                            {/* <Tooltip title="Update this month amount">
                            <EditOutlinedIcon fontSize="small" />
                            </Tooltip> */}
                              

                              {/* <SwapHorizIcon
                                fontSize="medium"
                                color="warning"
                                className="swapHorizon"
                                style={{ cursor: "pointer", marginTop:"20px" }}
                                onClick={() =>
                                  addTransactionHandler(
                                    data.budget_id,
                                    data.name,
                                    data.amount
                                  )
                                }
                              ></SwapHorizIcon> */}
                            </>
                          }
                        >
                          <div className="img-round">
                            <Box
                              component="img"
                              direction="column"
                              className="grid-item"
                              sx={{
                                maxHeight: { xs: 233, md: 167 },
                                maxWidth: { xs: 350, md: 250 },
                              }}
                              alt="Budget icon"
                              src={"./images/icons/" + data.budget_icon}
                            />
                          </div>
                          <div className="content_budget monthly-transaction">
                            <h4>
                              <span style={{color:'chocolate'}}>{escapeHtml(data.name)}{" "} </span>
                              {data.transactions.length > 0 ? (
                                <>
                                  <span className="dot">
                                    {data.transactions.length}
                                  </span>
                                  <Button className="listing-button" onClick={(event) => showTransactions(event, index)}>
                                    <FormatListBulletedIcon id={`show${index}`} fontSize="small" style={{ cursor: "pointer", marginRight:"auto" }} className="show-list-icon"  />
                                    <PlaylistRemoveIcon id={`strike${index}`} fontSize="small" style={{ cursor: "pointer", display:'none', marginRight:"auto" }} className="hide-list-icon" />
                                  </Button>
                                  
                                </>
                              ) : (
                                <></>
                              )}
                               {(session === "current" || session === "next") ? (
                                <span className="budget-amount">
                                 {currencyFormat(data.amount, currency)} 
                                {data.sum > 0 ? (
                                  <span className="paid-text">({currencyFormat(data.sum, currency)})</span>
                                ) : (
                                  <></>
                                )}
                              </span>
                               ):(
                                <span className="budget-amount">
                                  <span className="paid-text">{currencyFormat(data.sum, currency).toString()}</span>
                              </span>
                               )}
                              
                            </h4>
                            <div style={{ display:"flex", justifyContent:"space-between", float:'none', marginTop:'5px', color: '#88b334', width:'100%' }}>
                            <Typography className="upperText">
                              {data.pending_payment && data.pending_payment === true ? (
                                <span className="payment-left">Payment Date: {getOrdinal(data.date_of_month)}</span>   
                              ):(<span>Payment Date: {getOrdinal(data.date_of_month)} {data.pending_payment}</span>)}
                              {data.is_premium && data.left_premium >0 ? (<span className="text-black">(+{data.left_premium} Premium/EMI left)</span>):(<></>)}
                              {data.is_premium && data.left_premium === 0 ? (<span className="text-black">(Last Premium/EMI)</span>):(<></>)}
                              {data.doc_link ? (<a className="doc-icon-pos" rel="noreferrer" href={data.doc_link} target="_blank"><FileOpenIcon fontSize="small"/></a>):(<></>)}
                            </Typography>
                              <Button className="button-30" onClick={() =>
                                  addTransactionHandler(
                                    data.budget_id,
                                    data.name,
                                    data.amount,
                                    "Expense"
                                  )
                                }>Add Expense</Button>
                            </div>
                            
                          </div>
                        </ListItem>
                        {data.transactions.length > 0 ? (
                          <List
                            className={`transactions`}
                            id={`list${index}`}
                            aria-label="basic-list"
                            style={{ display: "none" }}
                          >
                            {data.transactions.map((data2, index2) => (
                              <ListItem key={index2} className={`${data2.note && data2.note.length> 23 ? "li-min-height": "" }`}>
                                <Grid container>
                                    <Grid item xs={2.5} >
                                      <Box className="tr-list-box">
                                        {currencyFormat(data2.amount, currency)}
                                        {data2.account_name ? (
                                        <span className={`abs-pos ${data2.note && data2.note.length> 23 ? "account-next-line": "" }`}><br/>{data2.account_name}</span>
                                        ) : (
                                          <></>
                                        )}
                                      </Box>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Box className="tr-list-box">
                                      <span className="date-show">{new Date(data2.transaction_date).getDate() +
                                          " " +
                                          new Date(
                                            data2.transaction_date
                                          ).toLocaleString("default", {
                                            month: "short",
                                          })} {" "}
                                          {new Date(data2.transaction_date).getFullYear()}</span>
                                        {data2.note}
                                        </Box>
                                      </Grid>
                                    <Grid item xs={1.5}>
                                      <Box className="tr-list-box">
                                        <Tooltip title="Update">
                                          <Button style={{minWidth:'24px', padding: '0px'}} onClick={() =>editTransactionHandler(data2,data.name, "Expense")}>
                                            <EditOutlinedIcon className="font-icon" />
                                          </Button>
                                        </Tooltip>
                                        
                                        <Tooltip title="Delete">
                                          <Button style={{minWidth:'24px', padding: '0px'}} className="delIcon" onClick={(event)=> deleteTransaction(data2.transaction_id)}>
                                            <DeleteOutlined className="font-icon"/>
                                          </Button>
                                        </Tooltip>
                                      </Box>
                                    </Grid>
                                  </Grid>
                                  {/* <span className="currencyAmount"> {currencyFormat(data2.amount, currency)}{" "}
                                   {data2.account_name ? (
                                  <span className="abs-pos"><br/>{data2.account_name}</span>
                                  ) : (
                                    <></>
                                  )}
                                </span>
                                <span className="dateTransaction"> {new Date(data2.transaction_date).getDate() +
                                  " " +
                                  new Date(
                                    data2.transaction_date
                                  ).toLocaleString("default", {
                                    month: "short",
                                  })}{" "}
                                {new Date(data2.transaction_date).getFullYear()}{" "}</span>
                                <span className="transactionData">{data2.note}</span>

                                <Tooltip title="Update">
                                  <Button className="transaction-edit" style={{minWidth:'24px'}} onClick={() =>editTransactionHandler(data2,data.name, "Expense")}>
                                    <EditOutlinedIcon />
                                  </Button>
                                </Tooltip>
                                
                                <Tooltip title="Delete">
                                  <Button style={{minWidth:'24px'}} className="delIcon" onClick={(event)=> deleteTransaction(data2.transaction_id)}>
                                    <DeleteOutlined/>
                                  </Button>
                                </Tooltip> */}
                                
                                  
                                {/* <p>{data2.amount}&nbsp; {data2.note}<p/> */}
                              </ListItem>
                            ))}
                          </List>
                        ) : (
                          <></>
                        )}
                        <Divider
                          sx={{
                            marginLeft: "5%",
                            marginRight: "5%",
                          }}
                        />
                      </div>
                    ))}
                  </List>
                ) : (
                  <></>
                )}
              </Demo>
            </Grid>
          </>
        ) : (
          <>
            <br />
            {/* <div>Monthly Income: {currencyFormat(totalIncome)}</div> */}
            <Grid item xs={12} md={12} id="income-section">
              <Demo style={{ minHeight: "500px" }}>
                {monthlyIncomeList && monthlyIncomeList.length > 0 ? (
                  <List>
                    {monthlyIncomeList.map((data, index) => (
                      <div key={index}>
                        <ListItem
                        className={getBadgeClasses(data,session) + " list-transaction"}
                          secondaryAction={
                            <>
                            
                              {/* <SwapHorizIcon
                                fontSize="medium"
                                color="warning"
                                className="swapHorizon"
                                style={{ cursor: "pointer", marginTop: '35px' }}
                                onClick={() =>
                                  addTransactionHandler(
                                    data.budget_id,
                                    data.name,
                                    data.amount
                                  )
                                }
                              ></SwapHorizIcon> */}
                            </>
                          }
                        >
                          <div className="img-round">
                            <Box
                              component="img"
                              direction="column"
                              className="grid-item"
                              sx={{
                                maxHeight: { xs: 233, md: 167 },
                                maxWidth: { xs: 350, md: 250 },
                              }}
                              alt="Budget icon"
                              src={"./images/icons/" + data.budget_icon}
                            />
                          </div>
                          <div className="content_budget">
                            <h4>
                              {escapeHtml(data.name)}{" "}
                              {data.transactions.length > 0 ? (
                                <>
                                  <span className="dot">
                                    {data.transactions.length}
                                  </span>
                                  <Button className="listing-button" onClick={(event) => showTransactions(event, index)}>
                                    <FormatListBulletedIcon id={`show${index}`} fontSize="small" style={{ cursor: "pointer", marginRight:"auto" }} className="show-list-icon" />
                                    <PlaylistRemoveIcon id={`strike${index}`} fontSize="small" style={{ cursor: "pointer", display:'none', marginRight:"auto" }} className="hide-list-icon" />
                                  </Button>
                                </>
                              ) : (
                                <></>
                              )}
                              <span className="budget-amount">
                                {currencyFormat(data.sum, currency)}                              
                              </span>
                            </h4>
                            <div style={{ display:"flex", justifyContent:"space-between", float:'none', marginTop:'5px', color: '#88b334', width:'100%' }}>
                            <Typography className="upperText" style={{ marginRight:"5px" }}>
                              {data.date_of_month ? (
                                <>Pay on {data.date_of_month}th</>
                              ) : (
                                <></>
                              )}
                            </Typography>
                            <Button className="button-30" onClick={() =>
                                  addTransactionHandler(
                                    data.budget_id,
                                    data.name,
                                    data.amount,
                                    "Income"
                                  )
                                }>Add Income</Button>
                                </div>
                          </div>
                        </ListItem>
                        {data.transactions.length > 0 ? (
                          <List
                            className={`transactions`}
                            id={`list${index}`}
                            aria-label="basic-list"
                            style={{ display: "none" }}
                          >
                       
                            {data.transactions.map((data2, index2) => (
                              <ListItem key={index2}>
                                <Grid container>
                                    <Grid item xs={2.5} >
                                      <Box className="tr-list-box">
                                        {currencyFormat(data2.amount, currency)}
                                      </Box>
                                    </Grid>
                                    <Grid item xs={8}>
                                      <Box className="tr-list-box">
                                      <span className="date-show">({new Date(data2.transaction_date).getDate() +
                                          " " +
                                          new Date(
                                            data2.transaction_date
                                          ).toLocaleString("default", {
                                            month: "short",
                                          })}){" "}
                                          {new Date(data2.transaction_date).getFullYear()}</span>
                                        {data2.note}
                                        </Box>
                                      </Grid>
                                    <Grid item xs={1.5}>
                                      <Box className="tr-list-box">
                                        <Tooltip title="Update">
                                          <Button style={{minWidth:'24px', padding: '0px'}} onClick={() =>editTransactionHandler(data2,data.name, "Expense")}>
                                            <EditOutlinedIcon className="font-icon" />
                                          </Button>
                                        </Tooltip>
                                        
                                        <Tooltip title="Delete">
                                          <Button style={{minWidth:'24px', padding: '0px'}} className="delIcon" onClick={(event)=> deleteTransaction(data2.transaction_id)}>
                                            <DeleteOutlined className="font-icon"/>
                                          </Button>
                                        </Tooltip>
                                      </Box>
                                    </Grid>
                                  </Grid>
                               {/* <span className="currencyAmount">{currencyFormat(data2.amount, currency)}{" "}</span>
                               <span className="dateTransaction">{new Date(data2.transaction_date).getDate() +
                                  " " +
                                  new Date(
                                    data2.transaction_date
                                  ).toLocaleString("default", {
                                    month: "short",
                                  })}{" "}
                                {new Date(data2.transaction_date).getFullYear()}{" "}</span>
                                <span className="transactionData">{data2.note}</span>
                                <Tooltip title="Update">
                                  <Button style={{minWidth:'24px'}} onClick={() =>editTransactionHandler(data2, data.name, "Income")}>
                                    <EditOutlinedIcon />
                                  </Button>
                                </Tooltip>
                                <Tooltip title="Delete">
                                  <Button style={{minWidth:'24px'}} className="delIcon" onClick={(event)=> deleteTransaction(data2.transaction_id)}>
                                    <DeleteOutlined />
                                  </Button>
                                </Tooltip> */}
                              </ListItem>
                            ))}
                          </List>
                        ) : (
                          <></>
                        )}

                        <Divider
                          sx={{
                            marginLeft: "5%",
                            marginRight: "5%",
                          }}
                        />
                      </div>
                    ))}
                  </List>
                ) : (
                  <></>
                )}
              </Demo>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default MonthlyTransaction;
